export default __webpack_public_path__ + "static/media/item3.6633d194.jpg";